import Router from 'vue-router';

const LoginPage = () => import('./pages/LoginPage.vue');
const DashboardLayout = () => import('./pages/Layout/DashboardLayout.vue');

const TableList = () => import('@/pages/TableList.vue');
import TokenService from './services/token.service';
const ColorsList = () => import('./pages/ColorsList');
const SeoList = () => import('./pages/SeoList');
const PropertiesList = () => import('./pages/PropertiesList');
const MaterialtypeList = () => import('./pages/MaterialtypeList');
const FooterList = () => import('./pages/FooterList');
const CollectionsList = () => import('./pages/CollectionsList');
const LabelsList = () => import('./pages/LabelsList');
const TopmenuList = () => import('./pages/TopmenuList');
const ProductList = () => import('./pages/ProductList');
const PhotosList = () => import('./pages/PhotosList');
const FilesList = () => import('./pages/FilesList');
const NotFoundList = () => import('./pages/NotFoundList');
const AboutUsList = () => import('./pages/AboutUsList');
const ContactList = () => import('./pages/ContactList');
const ContactFormsList = () => import('./pages/ContactFormsList');
const SectionsList = () => import('./pages/SectionsList');
const PrivatePolicyList = () => import('./pages/PrivatePolicyList');
const DeliveryTypesList = () => import('@/pages/DeliveryTypesList');
const TermsAndConditionList = () => import('@/pages/TermsAndConditionList');
const BlogRowList = () => import('@/pages/BlogRowList');
const BlogSectionsList = () => import('@/pages/BlogSectionsList');
const GroupsList = () => import('@/pages/GroupsList');
const OrdersList = () => import('@/pages/OrdersList');

const router = new Router({
    mode: 'history',
    linkExactActiveClass: 'nav-item active',
    routes: [
        {
            path: '/login',
            component: LoginPage,
            meta: {
                public: true,
                onlyWhenLoggedOut: true
            },
        },
        {
            path: '/',
            component: DashboardLayout,
            redirect: '/zamowienia',
            children: [
                {
                    path: "footer",
                    name: "Stopka",
                    component: FooterList
                },
                {
                    path: "colors",
                    name: "Kolory",
                    component: ColorsList
                },
                {
                    path: "seo",
                    name: "SEO",
                    component: SeoList
                },
                {
                    path: "table",
                    name: "Slider",
                    component: TableList
                },
                {
                    path: "properties",
                    name: "Właściwości",
                    component: PropertiesList
                },
                {
                    path: "materialtypes",
                    name: "Typy materiału",
                    component: MaterialtypeList
                },
                {
                    path: "collections",
                    name: "Kolekcje",
                    component: CollectionsList
                },
                {
                    path: "collections/:id",
                    name: "Sekcje",
                    component: SectionsList
                },
                {
                    path: "labels",
                    name: "Etykiety",
                    component: LabelsList
                },
                {
                    path: "groups",
                    name: "Grupy",
                    component: GroupsList
                },
                {
                    path: "topmenu",
                    name: "Menu górne",
                    component: TopmenuList
                },
                {
                    path: "products",
                    name: "Produkty",
                    component: ProductList
                },
                {
                    path: "rodzaj-dostawy",
                    name: "Rodzaj dostawy",
                    component: DeliveryTypesList
                },
                {
                    path: "blog",
                    name: "Blog",
                    component: BlogRowList
                },
                {
                    path: "blog/:id",
                    name: "Wpisy",
                    component: BlogSectionsList
                },
                {
                    path: "photos/:id",
                    name: "Zdjęcia",
                    component: PhotosList
                },
                {
                    path: "files/:id",
                    name: "Pliki",
                    component: FilesList
                },
                {
                    path: "404",
                    name: "404",
                    component: NotFoundList
                },
                {
                    path: "o-nas",
                    name: "O nas",
                    component: AboutUsList
                },
                {
                    path: "kontakt",
                    name: "Kontakt",
                    component: ContactList
                },
                {
                    path: "formularze",
                    name: "Formularze",
                    component: ContactFormsList
                },
                {
                    path: "polityka-prywatnosci",
                    name: "Polityka prywatności",
                    component: PrivatePolicyList
                },
                {
                    path: "regulamin-sklepu",
                    name: "Regulamin sklepu",
                    component: TermsAndConditionList
                },
                {
                    path: "zamowienia",
                    name: "Zamówienia",
                    component: OrdersList
                },
                {
                    path: 'logout/',
                    name: 'Log out',
                    beforeEnter: (to, from, next) => {
                        TokenService.removeTokens();
                        next('/login');
                    },
                }
            ]
        },
    ]
});

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public);
    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);

    const loggedIn = !!TokenService.getAccessToken();

    if (!isPublic && !loggedIn) {
        return next({
            path: '/login',
            query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
        });
    }

    // Do not allow user to visit login page or register page if they are logged in
    if (loggedIn && onlyWhenLoggedOut) {
        return next('/');
    }

    next();
});

export default router;
